export default __webpack_public_path__ + "static/media/blog-post-layout-04-img-10.223d3684.jpg";